import ReactModal from 'react-modal';
import ReactPlayer from 'react-player';
import './VideoLightbox.css';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  videoUrl: string;
}

// Bind modal to your appElement for accessibility
ReactModal.setAppElement('#root');

export const VideoLightbox = ({ isOpen, onClose, videoUrl }: Props): JSX.Element => {
  const ModalComponent = ReactModal as any;
  
  return (
    <ModalComponent
      isOpen={isOpen}
      onRequestClose={onClose}
      className="fixed inset-0 flex items-center justify-center p-4 pointer-events-none"
      overlayClassName="fixed inset-0 bg-black bg-opacity-90 z-50 cursor-pointer"
      onClick={onClose}
    >
      <div 
        className="relative w-full max-w-[1200px] aspect-video pointer-events-auto"
        onClick={e => e.stopPropagation()} // Prevent clicks on video from closing
      >
        <button
          onClick={onClose}
          className="absolute -top-10 right-0 text-white hover:text-gray-300 text-3xl z-10"
          aria-label="Close"
        >
          ×
        </button>
        <div className="react-player-wrapper">
          <ReactPlayer
            url={videoUrl}
            width="100%"
            height="100%"
            className="react-player"
            controls
            playing
            config={{
              file: {
                attributes: {
                  controlsList: 'nodownload',
                  style: {
                    '--video-controls-bg': 'rgba(0, 0, 0, 0.5)',
                  },
                },
                tracks: [],
              },
            }}
          />
        </div>
      </div>
    </ModalComponent>
  );
}; 